import { Layout, Space } from "antd";
import React, { Suspense, useEffect } from "react";
import Card from "../Card";
import Image from "../Image";

const MarkdownRenderer = React.lazy(() => import("react-markdown"));

const { Content } = Layout;

type FullScreenDocumentProps = {
  icon?: string;
  onClickIcon?: () => void;
  files: Record<string, string>;
  footer: React.ReactNode;
};

const FullScreenDocument = ({
  icon,
  onClickIcon,
  files,
  footer,
}: FullScreenDocumentProps) => {
  const [data, setData] = React.useState({} as { [key: string]: string });

  useEffect(() => {
    for (const file of Object.entries(files)) {
      fetch(file[1] as string)
        .then((response) => response.text())
        .then((text) => {
          setData((data) => {
            return {
              ...data,
              [file[0]]: text,
            };
          });
        });
    }
  }, [files]);

  return (
    <Layout className="full_screen">
      <Layout.Header className="full_screen__document__header">
        <Image
          src={icon}
          width="42px"
          preview={false}
          onClick={onClickIcon}
          className="full_screen__document__header__icon"
        />
      </Layout.Header>
      <Content>
        <Space
          size="large"
          direction="vertical"
          className="full_screen__document__content"
        >
          {Object.keys(data).map((file) => (
            <Card
              key={file}
              title={file}
              bordered={true}
              className="full_screen__document__card"
            >
              <Suspense fallback={null}>
                <MarkdownRenderer>{data[file]}</MarkdownRenderer>
              </Suspense>
            </Card>
          ))}
        </Space>
      </Content>
      {footer}
    </Layout>
  );
};

export default FullScreenDocument;
